export const Steps = ({ step, heading, text, icon }) => {
  return (
    <>
      <div className="stepContainer py-5">
        <div className="championsTrophyStep">{step}</div>
        <div className="stepIcons">
          <img src={icon} alt="" />
        </div>
        <div className="stepHeading mt-3">{heading}</div>
        <div className="stepTxt mt-2">{text}</div>
      </div>
    </>
  );
};
